import { Component } from '@angular/core';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  standalone: false,
  styleUrls: ['./admin.component.scss', '../styles/shared.scss']
})
export class AdminComponent {}
